import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-news-back' })
export class NewsBackComponent {
	constructor(private element: HTMLElement) {
		this.addClickListener();
	}

	addClickListener() {
		this.element.addEventListener('click', function () {
			history.back();
		});
	}
}
